import { initThemeToggle } from './theme-toggle.js';
import { initScrollAnimations } from './scroll-animations.js';
import { buildNavigation, buildFooter, buildSocialBar } from './navigation.js';
import { initModalsAndDrawers } from './modal-drawer.js';
import { loadJSON } from './data-loader.js';

export async function initPage() {
  await buildSocialBar();
  await buildNavigation();
  await buildFooter();
  initThemeToggle();
  initScrollAnimations();
  
  const siteData = await loadJSON('/data/site.json');
  if (siteData) {
      initModalsAndDrawers(siteData);
  }
}
